import { render, staticRenderFns } from "./tm-menu-item-page.vue?vue&type=template&id=76ca1a41&scoped=true&"
import script from "./tm-menu-item-page.vue?vue&type=script&lang=ts&"
export * from "./tm-menu-item-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-menu-item-page.vue?vue&type=style&index=0&id=76ca1a41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca1a41",
  null
  
)

export default component.exports